import React from 'react'
import { BookOpen } from '@/ui/icons'
import { Button } from '@/ui/components'
import { cn } from '@/shared/utils'

interface LibraryWaypointsToggleProps {
  showLibraryWaypoints: boolean
  onToggle: (show: boolean) => void
  className?: string
}

export function LibraryWaypointsToggle({
  showLibraryWaypoints,
  onToggle,
  className
}: LibraryWaypointsToggleProps) {
  return (
    <Button
      variant={showLibraryWaypoints ? 'default' : 'outline'}
      size="sm"
      onClick={() => onToggle(!showLibraryWaypoints)}
      className={cn(
        'flex items-center gap-2 shadow-md',
        className
      )}
      title={showLibraryWaypoints ? 'Hide library waypoints' : 'Show library waypoints'}
    >
      <BookOpen className="w-4 h-4" />
      <span className="text-xs font-medium">
        {showLibraryWaypoints ? 'Hide Library' : 'Show Library'}
      </span>
    </Button>
  )
}

